<template>
	<!-- 广告管理 -->
	<div class="container_page">
		<div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div>
		<a-form layout="inline">
			<a-form-item label="广告标题">
				<a-input placeholder="请输入广告标题" v-model="filterData.bannerTitle" />
			</a-form-item>
<!--			<a-form-item label="广告位置">-->
<!--				<a-select style="width: 200px" v-model="filterData.bannerType" class="mr12" placeholder="请选择广告位置"-->
<!--					show-search option-filter-prop="name" :filter-option="filterOption">-->
<!--					<a-select-option v-for="(item, index) of bannerTypeList" :key="index" :value="item.value">-->
<!--						{{ item.label }}-->
<!--					</a-select-option>-->
<!--				</a-select>-->
<!--			</a-form-item>-->
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>
				<a-button class="mr12" type="primary" @click="toAdd" v-if="filterData.lang === 'CH'">添加广告</a-button>
			</a-form-item>
		</a-form>

		<a-radio-group style="margin-bottom: 16px;margin-top: 16px;" v-model="filterData.bannerType"
			button-style="solid" @change="changeTabTop">
			<a-radio-button style="width: 150px;text-align: center;" value="FACTORY">工厂</a-radio-button>
			<a-radio-button style="width: 150px;text-align: center;" value="BRAND">品牌</a-radio-button>
		</a-radio-group>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="bannerUrlRender" slot-scope="text, record">
				<viewer :images="[record.bannerUrl]">
					<div class="er_content">
						<img class="er_content_img" :src="img" v-for="(img,index) in [record.bannerUrl]" :key="index">
					</div>
				</viewer>
			</template>

			<!-- 广告位置 -->
			<template slot="bannerTypeRender" slot-scope="text, record">
				<div>
					<span>{{record.bannerType=='FACTORY'?'工厂':'品牌'}}</span>
				</div>
			</template>
			<!-- 跳转类型 -->
			<template slot="jumpTypeRender" slot-scope="text, record">
				<div v-if="record.jumpType != null">
					{{
				            $enums.jumpTypeEnum.getLabelByValue(
				              record.jumpType
				            )
				          }}
				</div>
				<div v-else>无跳转</div>
			</template>
			<!-- 期限 -->
			<template slot="startTimeRender" slot-scope="text, record">
				<div>
					<span>{{record.startTime}}-{{record.endTime}}</span>
				</div>
			</template>

			<template slot="bannerStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.bannerStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.bannerStatus === true">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else-if="record.bannerStatus === false">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>
			</template>
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template>

			<template slot="action" slot-scope="text, record">
				<span><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm v-if="filterData.lang === 'CH'" title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
					<a-button type="link">删除</a-button>
				</a-popconfirm>
			</template>
		</a-table>
		<a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
			<template slot="footer">
				<a-button @click="imgModel.flag = false">关闭</a-button>
			</template>
			<span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px" />
			</span>
		</a-modal>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="广告位置">
							<a-input style="width: 180px;" v-model="editModel.businessLogo" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="广告标题">
							<a-input style="width: 180px;" v-model="editModel.businessLogo" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="排序">
							<a-input style="width: 180px;" v-model="editModel.businessLogo" />
							<span>数字越大越靠前</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="开始时间">
							<a-input style="width: 180px;" v-model="editModel.businessLogo" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="结束时间">
							<a-input style="width: 180px;" v-model="editModel.businessLogo" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="发布状态">
							<a-input style="width: 180px;" v-model="editModel.businessLogo" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="图片" prop="businessName">
							<a-input style="width: 180px;" v-model="editModel.businessName" />
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="视频" prop="businessEnName">
							<a-input style="width: 180px;" v-model="editModel.businessEnName" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		getBannerListApi, //  列表
		// getBannerDetailApi, //  详情
		saveBannerApi, //  新增编辑
		deleteBannerApi, // 删除
		updateBannerStatusApi, //  状态
		updateBannerSortApi, // 排序
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				bannerTypeList: [{
						label: "工厂",
						value: 'FACTORY',
					},
					{
						label: "品牌",
						value: 'BRAND',
					},
				],
				commodityStatusList: [{
						label: "开启",
						value: true,
					},
					{
						label: "关闭",
						value: false,
					},
				],
				columns: [{
						title: '序号',
						dataIndex: 'index',
						key: 'index',
						customRender: (text, record, index) => {
							return (this.pageInfo.current - 1) * this.pageInfo.pageSize + index + 1
						}
					},
					{
						title: '广告标题',
						dataIndex: 'bannerTitle',
						key: 'bannerTitle',
					},
					{
						title: '广告图片',
						dataIndex: 'bannerUrl',
						key: 'bannerUrl',
						scopedSlots: {
							customRender: "bannerUrlRender"
						},
					},
					{
						title: '广告位置',
						dataIndex: 'bannerType',
						key: 'bannerType',
						scopedSlots: {
							customRender: "bannerTypeRender"
						},
					},
					{
						title: '跳转类型',
						dataIndex: 'jumpType',
						key: 'jumpType',
						scopedSlots: {
							customRender: "jumpTypeRender"
						},
					},
					{
						title: '期限',
						dataIndex: 'startTime',
						key: 'startTime',
						scopedSlots: {
							customRender: "startTimeRender"
						},
					},
					{
						title: '排序',
						dataIndex: 'sort',
						key: 'sort',
						scopedSlots: {
							customRender: "indexSortender"
						},
					},
					{
						title: '点击次数',
						dataIndex: 'viewNum',
						key: 'viewNum',
					},
					{
						title: '状态',
						dataIndex: 'bannerStatus',
						key: 'bannerStatus',
						scopedSlots: {
							customRender: "bannerStatusRender"
						},
					},
					{
						title: '创建日期',
						dataIndex: 'createTime',
						key: 'createTime',

					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					giftCardId: 0,
					giftCardStatus: undefined,
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "新建其他标签信息",
					"businessId": 0, //工厂名称ID/品牌Id
					"businessLogo": "", //LOGO
					"businessName": "", //工厂名称/品牌名称
					"businessEnName": "", //工厂名称/品牌名称  英文
					"businessType": "", //类型    FACTORY 工厂 、BRABD 品牌 、SUPPLIER 供应商
					onOk: () => {},
				},
				formState: {
					"iconUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					lang: "CH",
					bannerType: "FACTORY",
					bannerTitle: "",
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('adManage_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.getData(1);
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('adManage_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			changeTabTop(e) {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},
			handlePublishChange(checked, record) {
				const content = checked ?
					'切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？' :
					'切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
				this.$confirm({
					title: '操作确认',
					content,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						updateBannerStatusApi({
							"bannerId": record.bannerId
						}).then(res => {
							if (res.resultStatus) {
								this.$message.success("修改成功");
								this.getData(this.pageInfo.current);
							}
						}).catch(err => console.error(err));
					}
				});
			},
			handleSaveSort(record) {
				if (record.sort === undefined || record.sort === null || record.sort === '') return
				updateBannerSortApi({
					sort: record.sort,
					bannerId: record.bannerId
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current)
					} else {
						this.$message.error('保存失败')
					}
				}).catch(() => this.$message.error('保存失败'))
			},
			handleCategoryChange() {
				// 切换分类后，重置页码并刷新表格
				this.pageInfo.current = 1;
				this.loadTableData();
			},
			handleBlur() {},
			handleFocus() {},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData.bannerTitle =  null
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;

				getBannerListApi({
						bannerType: this.filterData.bannerType,
						lang: this.filterData.lang,
						bannerTitle: this.filterData.bannerTitle,
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.$router.push({
					name: 'ADDETAIL',
					params: {
						id: 0,
					}
				});
			},
			toEdit(data) {
				this.$router.push({
					name: 'ADDETAIL',
					params: {
						id: data.bannerId
					}
				});
			},
			confirm() {

			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			sureDelete(record) {
				if (this.loading) {
					return;
				}
				this.loading = true;
				deleteBannerApi({
						bannerId: record.bannerId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
							this.tipsModel.flag = false;
						} else {}
					})
					.catch((error) => {})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 上传文件
			handleUpdataFile(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					if (file) {
						const form = new FormData();
						form.append("file", file);
						getOssAuth(form).then((res) => {
							if (res.resultStatus) {
								this.editModel.iconUrl = res.resultData.fileLink;
							}
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}
</style>
